export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const PAGE_SIZE = 12;
export const KEY = 'ab545a08-37fd-4bc2-94e6-bc1df9decc6c';
export const MODAL_CLOSE_SEC = 2500;
